/**
 * @desc 导出物流追踪SKU单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackSkuReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackSkuReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
